import { DateTimeBox } from '@apply/components';
import { useBorrowerEsignDate } from '../../../../../queries/BorrowerFields/EsignFields';
import { formatDate } from '../../../../../../../../admin/src/common/SharedFunctions';

export const EsignDate: React.FC = () => {
    const [date, set_date] = useBorrowerEsignDate();

    if (date != formatDate(new Date())) set_date(formatDate(new Date()));

    return (
        <DateTimeBox
            id='dateOfPurchase'
            dataTestid='date-of-purchase'
            value={date ?? ''}
            onChange={(value) => set_date(value)}
            label='Date'
            readOnly={true}
        />
    );
};
